import { computed, observable, makeObservable } from 'mobx';
import {HomeworkRole} from './homework-models';

interface Provider {
  readonly joined: boolean;
  readonly homeworkRole: HomeworkRole;
  readonly homeworkId: number;
}

class HomeworkJoinedState {
  @observable.ref
  private provider: Provider | null = null;

  constructor() {
    makeObservable(this);
  }

  setProvider(provider: Provider | null) {
    this.provider = provider;
  }

  @computed
  get joined() {
    if (this.provider === null)
      return false;
    return this.provider.joined;
  }

  @computed
  get role(): HomeworkRole | null {
    if (this.provider === null)
      return null;
    return this.provider.homeworkRole;
  }

  @computed
  get homeworkId(): number | null {
    if (this.provider === null)
      return null;
    return this.provider.homeworkId;
  }
}

export const homeworkJoinedState = new HomeworkJoinedState();
